module.exports = __webpack_public_path__ + "static/media/carta_61.fe235d5b.jpg";